import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import sha256 from 'crypto-js/sha256';
import Base64 from 'crypto-js/enc-base64';

import Button from '../../../shared/button/components/button';
import nagaLogo from '../../../../common/images/naga-logo.png';
import { validate } from '../validators/login-validators';
import DefaultInput from '../../../shared/default-input/components/default-input';
import loginConstants from '../constants/login-constants';
import { login, handleLoginError } from '../actions/login-actions';
import { toggleForgotPasswordModal } from '../../forgot-password/actions/forgot-password-actions';
import MessageBox from '../../../shared/error-message/components/message-box';
import messageBoxConstants from '../../../shared/error-message/constants/message-box-constatns';
import constants from '../../../../common/constants';
import ForgotPasswordModal from '../../forgot-password/components/forgot-password-modal';
import RenderIf from '../../../shared/render-if/components/render-if';

import '../styles/login.css';

class Login extends Component {
  handleFormSubmit(values) {
    const { login } = this.props;
    const password = sha256(constants.magic_salt + values[loginConstants.fields.password]).toString(Base64);
    login(values[loginConstants.fields.username], password);
  }

  clearErrors() {
    const { loginErrors, handleLoginError } = this.props;

    if (loginErrors) {
      handleLoginError(null);
    }
  }

  toggleForgotPasswordModal() {
    const { toggleForgotPasswordModal } = this.props;

    toggleForgotPasswordModal(true);
  }

  render() {
    const { handleSubmit, httpInProgress, loginErrors, showForgotPasswordModal } = this.props;
    const { t } = this.context;

    return (
      <div className="login-container">
        <RenderIf if={showForgotPasswordModal}>
          <ForgotPasswordModal />
        </RenderIf>
        <div className="login-container__wrapper">
          <div className="login-container__wrapper__main">
            <img src={nagaLogo} alt="Naga Logo" className="login-container__wrapper__main__logo" />
            <h2>{t('LOGIN.TITLE')}</h2>
            <form onSubmit={handleSubmit(values => this.handleFormSubmit(values))} noValidate className="login-container__wrapper__main__form">
              <div className="row">
                <div className="col-md-12 m-b-20">
                  <Field name={loginConstants.fields.username} label={'LOGIN.USERNAME_LABEL'} disabled={httpInProgress} component={DefaultInput} onChange={() => this.clearErrors()} />
                </div>
                <div className="col-md-12">
                  <Field
                    name={loginConstants.fields.password}
                    label={'LOGIN.PASSWORD_LABEL'}
                    disabled={httpInProgress}
                    component={DefaultInput}
                    type={constants.input_types.password}
                    onChange={() => this.clearErrors()}
                  />
                </div>
              </div>
              <div className="row m-t-20">
                <div className="col-md-12">
                  <MessageBox message={loginErrors} type={messageBoxConstants.message_types.error} />
                </div>
              </div>
              <Button label={'LOGIN.SUBMIT_BUTTON'} customClass={'affiliate-btn-blue m-t-20'} disabled={httpInProgress} type={'submit'} />
            </form>
            <Button label={'LOGIN.FORGET_PASSWORD_BUTTON'} onClick={() => this.toggleForgotPasswordModal()} customClass={'m-t-20'} />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  httpInProgress: state.httpInProgressReducer.httpInProgress,
  loginErrors: state.loginReducer.loginErrors,
  showForgotPasswordModal: state.forgotPasswordReducer.showForgotPasswordModal,
});

const mapDispatchToProps = dispatch => ({
  login: (username, password) => {
    dispatch(login(username, password));
  },
  handleLoginError: error => {
    dispatch(handleLoginError(error));
  },
  toggleForgotPasswordModal: show => {
    dispatch(toggleForgotPasswordModal(show));
  },
});

Login.contextTypes = {
  t: PropTypes.func.isRequired,
};

Login = reduxForm({
  form: loginConstants.form_name,
  validate,
})(Login);

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/app/main/login/components/login.js